import { Link } from "react-router-dom";
import { videos } from "@/mocks/videos";

export default function FeaturedSection() {
  const hotVideos = videos.filter((v) =>
    ["51-video", "hot-video", "new-video"].includes(v.category) || parseInt(v.views.replace(/[^0-9]/g, "")) > 150
  ).slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 max-w-screen-2xl mx-auto">
      <div className="text-center mb-8">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
          热门推荐
        </h2>
        <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
          全网热搜视频内容，涵盖数字视频网站热门资源，51视频等精彩不断，持续为您更新
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {hotVideos.map((video) => (
          <Link
            key={video.id}
            to={`/article/${video.id}`}
            className="group flex gap-4 p-4 bg-background-50 rounded-lg border border-background-200/70 cursor-pointer transition-all duration-300 hover:border-primary-200"
            data-product-shop=""
          >
            <div className="relative w-32 md:w-40 aspect-video rounded-md overflow-hidden shrink-0">
              <img
                src={video.cover}
                alt={video.title}
                title={`${video.title} - 樱花视频热门推荐`}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute bottom-1 right-1 bg-black/70 text-white text-xs px-1.5 py-0.5 rounded">
                {video.duration}
              </div>
            </div>
            <div className="flex flex-col justify-between flex-1 min-w-0">
              <div>
                <h3 className="text-sm font-semibold text-foreground-950 mb-1 line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {video.title}
                </h3>
                <p className="text-xs text-foreground-600 line-clamp-2">
                  {video.description}
                </p>
              </div>
              <div className="flex items-center gap-2 flex-wrap mt-2">
                {video.tags.map((tag) => (
                  <span
                    key={tag}
                    className="text-xs bg-secondary-100 text-secondary-900 px-2 py-0.5 rounded-full whitespace-nowrap"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}